import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { API_BASE_URL } from "../config";



const container = {
  maxWidth: "750px",
  margin: "40px auto",
  padding: "30px",
  background: "#ffffff",
  borderRadius: "12px",
  boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
  border: "1px solid #ddd",
};

const row = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "10px",
};

const line = {
  borderTop: "1px solid #ddd",
  margin: "20px 0",
};

const SwapInvoice = () => {
  const { swapRef } = useParams();
  const [deal, setDeal] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadDeal();
  }, []);

  const loadDeal = async () => {
    try {
      const res = await fetch(
       `${API_BASE_URL}/api/swaps/deal-by-reference/${swapRef}`
      );
      const data = await res.json();

      if (data.success) {
        setDeal(data.deal);
      }
    } catch (err) {
      console.error("Invoice load error:", err);
    }
    setLoading(false);
  };

  if (loading) {
    return <p style={{ textAlign: "center", marginTop: "40px" }}>Loading invoice…</p>;
  }

  if (!deal) {
    return (
      <div style={container}>
        <h2 style={{ color: "red" }}>Invoice Not Found</h2>
        <p>We couldn't locate your invoice.</p>

        <Link to="/dashboard">
          <button
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              background: "#2e7d32",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
            }}
          >
            Return to Dashboard
          </button>
        </Link>
      </div>
    );
  }

  // Determine payer fields
  const isUserA = deal.userA === deal.userId;
  const paymentRef = isUserA ? deal.paymentA_reference : deal.paymentB_reference;
  const paymentAmount = isUserA ? deal.paymentA_amount : deal.paymentB_amount;
  const paymentTime = isUserA ? deal.paymentA_time : deal.paymentB_time;
  const otherPaid = isUserA ? deal.paymentB : deal.paymentA;

  return (
    <div style={container}>
      {/* HEADER */}
      <h1 style={{ textAlign: "center", marginBottom: "10px" }}>
        Client Exchange Pty Ltd
      </h1>
      <p style={{ textAlign: "center", marginBottom: "20px", color: "#555" }}>
        ABN: 23 692 732 157  
        <br />
        Verified Marketplace for Lawn & Garden Businesses
      </p>

      {/* PAID BADGE */}
      <div
        style={{
          padding: "10px 25px",
          background: "#2e7d32",
          color: "white",
          borderRadius: "6px",
          display: "inline-block",
          marginBottom: "20px",
          fontWeight: "bold",
        }}
      >
        PAID
      </div>

      {/* INVOICE META */}
      <div style={row}>
        <strong>Invoice #:</strong>
        <span>{swapRef}</span>
      </div>

      <div style={row}>
        <strong>Deal ID:</strong>
        <span>{deal.id}</span>
      </div>

      <div style={row}>
        <strong>Date Paid:</strong>
        <span>{paymentTime ? new Date(paymentTime).toLocaleString() : "-"}</span>
      </div>

      <div style={row}>
        <strong>Transaction Ref:</strong>
        <span>{paymentRef}</span>
      </div>

      <div style={line} />

      {/* ITEM */}
      <h3>Swap Fee</h3>

      <div style={row}>
        <span>Swap Activation Fee</span>
        <strong>${paymentAmount}</strong>
      </div>

      <div style={row}>
        <span>GST (10%)</span>
        <strong>${(paymentAmount / 11).toFixed(2)}</strong>
      </div>

      <div style={row}>
        <span>Total</span>
        <strong>${paymentAmount}</strong>
      </div>

      <div style={line} />

      {/* SWAP SUMMARY */}
      <h3>Swap Summary</h3>

      <div style={row}>
        <span>Your Listing</span>
        <strong>{deal.listingA} & {deal.listingB}</strong>
      </div>

      <div style={row}>
        <span>Your Payment Status</span>
        <strong style={{ color: "green" }}>Paid ✔</strong>
      </div>

      <div style={row}>
        <span>Other User Payment</span>
        {otherPaid ? (
          <strong style={{ color: "green" }}>Paid ✔</strong>
        ) : (
          <strong style={{ color: "#f57c00" }}>Waiting…</strong>
        )}
      </div>

      <div style={line} />

      {/* FOOTER */}
      <p style={{ color: "#777", textAlign: "center" }}>
        Thank you for using Client Exchange!  
        <br />
        A full receipt has also been emailed to you.
      </p>

      <Link to="/dashboard">
        <button
          style={{
            marginTop: "25px",
            padding: "12px 25px",
            background: "#2e7d32",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontSize: "16px",
            width: "100%",
          }}
        >
          Return to Dashboard
        </button>
      </Link>
    </div>
  );
};

export default SwapInvoice;

